"use client";

import { Container } from "@repo/ui/Container";
import { Box } from "@repo/ui/Box";
import { Section, SectionProps } from "@repo/ui/Section";
import { cn } from "@repo/utils/cn";

import { TitleHalf, TitleHalfProps } from "@repo/ui/TitleHalf";

export type ThanksSectionProps = {
  head: TitleHalfProps | null;
  mode?: "" | "dark" | "bright";
  onButtonClick?: () => void;
} & SectionProps;

export function ThanksSection({
  className,
  head,
  mode,
  onButtonClick,
  ...props
}: ThanksSectionProps) {
  return (
    <Section
      {...props}
      className={cn(
        "ui:bg-backgroundPrimary ui:pb-sectionContained",
        {
          "ui:bg-backgroundPrimary ui:brightMode": mode === "bright",
          "ui:bg-backgroundSecondary ui:darkMode": mode === "dark",
        },
        className,
      )}
    >
      <Container
        className={
          "ui:gap-x-mulitContainerColumnGutter ui:gap-y-mulitContainerColumnGutter ui:pb-containerAplifiedBottom ui:xl:gap-x-containerGutter"
        }
      >
        <Box variant={"full"} className={"ui:flex ui:justify-center"}>
          <div
            className={
              "ui:flex ui:flex-col ui:items-center ui:justify-center ui:gap-7 ui:overflow-hidden ui:px-9 ui:py-large ui:text-center ui:md:w-major "
            }
          >
            {head && (
              <TitleHalf
                {...head}
                onButtonClick={onButtonClick}
                className={
                  "ui:flex ui:flex-col ui:items-center ui:justify-center"
                }
              />
            )}
          </div>
        </Box>
      </Container>
    </Section>
  );
}
